module.exports = __webpack_public_path__ + "img/coinbankC07.e19ed043.jpg";